<div class="row">
  <div class="col-6">
    <h2>{{ buttonTitle }}</h2>
  </div>
  <div class="col-sm-6">
    <button type="submit" style="float: right" class="btn btn-primary px-4" (click)="onBack()">
      Back
    </button>
    <button type="submit" (click)="onSubmit()" style="float: right; margin-right: 20px" class="btn btn-primary px-4">
      Save
    </button>
  </div>
</div>

<div class="col-12" style="margin-top: 30px">
  <nb-card class="custom-card">
    <nb-card-body style="position: relative">
      <form [formGroup]="storeForm">
        <div class="row">
          <div class="col-sm-6">
            <label class="form-label">Name</label>
            <input class="form-control" placeholder="Enter Name" formControlName="name" nbInput />
          </div>

          <div class="col-sm-6">
            <label class="form-label">Email</label>
            <input type="email" class="form-control" placeholder="Enter Email" formControlName="email" nbInput />
          </div>
        </div>

        <div class="row" style="margin-top: 30px">
          <div class="col-sm-6">
            <label class="form-label">Status</label>
            <ng-select formControlName="status">
              <ng-option *ngFor="let status of data" [value]="status.status">{{
                status.name
                }}</ng-option>
            </ng-select>
          </div>

          <div class="col-sm-6">
            <label class="form-label">Phone</label>
            <input class="form-control" pattern="[0-9]*" placeholder="Enter Phone Number" formControlName="phone"
              (input)="onPhoneInput($event)" nbInput>
            <!-- <input class="form-control" placeholder="Enter Phone Number" formControlName="phone" nbInput /> -->
          </div>
        </div>

        <div class="row" style="margin-top: 30px">
          <div class="col-sm-6">
            <label class="form-label">Role</label>
            <ng-select formControlName="role">
              <ng-option *ngFor="let role of roledata" [value]="role.role">{{
                role.name
                }}</ng-option>
            </ng-select>
          </div>

          <div class="col-sm-6" *ngIf="storeForm.get('role').value !== 'chain_manager' && storeForm.get('role').value !== 'clerk' && (!id || (id && storeForm.get('role').value === 'manager'))">
            <label class="form-label">Stores</label>
            <ng-select formControlName="storeId" [multiple]="true" groupBy="selectedAllGroup" [selectableGroup]="true"
              placeholder="Select Stores">
              <ng-option *ngFor="let data of storeData" [value]="data._id">{{data.storeName}}
              </ng-option>
            </ng-select>
          </div>

          <div class="col-sm-6" *ngIf="storeForm.get('role').value === 'clerk'">
            <label class="form-label">Assigned Stores</label>
            <ng-select formControlName="assignedStores" [multiple]="true" groupBy="selectedAllGroup" [selectableGroup]="true"
              placeholder="Select Assigned Stores">
              <ng-option *ngFor="let data of storeData" [value]="data._id">{{data.storeName}}
              </ng-option>
            </ng-select>
          </div>

          <div class="col-sm-6" *ngIf="storeForm.get('role').value === 'chain_manager'">
            <div class="alert alert-info" style="margin-top: 28px; font-size: 14px">
              Chain managers are assigned to stores through Chain Management. No direct store assignment is needed.
            </div>
          </div>
        </div>

        <div class="row" style="margin-top: 30px">
          <div class="col-sm-12">
            <label class="form-label d-block">Receive system-down notifications</label>
            <nb-toggle formControlName="systemDownNotifications" class="mr-2"></nb-toggle>
          </div>
        </div>

        <div class="row" style="margin-top: 20px" *ngIf="storeForm.get('systemDownNotifications').value === true">
          <div class="col-sm-6">
            <label class="form-label">Notify for stores</label>
            <ng-select formControlName="systemDownStores" [multiple]="true" groupBy="selectedAllGroup"
              [selectableGroup]="true" placeholder="Select stores (leave empty for all accessible stores)">
              <ng-option *ngFor="let data of storeData" [value]="data._id">{{data.storeName}}</ng-option>
            </ng-select>
            <small class="text-muted">Leave empty to be notified for all your accessible stores</small>
          </div>
        </div>

        <div class="row" style="margin-top: 30px">

          <div *ngIf="isShowPaswordField==true" style="float: right" class="col-sm-6">
            <label class="form-label">Password </label>
            <input [type]="showPassword ?   'password':'text'" class="form-control" placeholder="Enter Password"
              formControlName="password" nbInput />
            <button class="toggle_password" type="button" *ngIf="storeForm.get('password').value !== ''"
              (click)="togglePasswordVisibility()">
              <i class="fa" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword" aria-hidden="true"></i>

            </button>

          </div>

          <div class="col-sm-2">
            <label>Profile Image</label><br />
            <div class="imageWidth">
              <label class="file">
                <input type="file" name="image" accept="image/*" id="exampleInputFile"
                  (change)="updateImage($event, 'Image')" formControlName="image" />
                <span *ngIf="!profileImg||profileImg==null||profileImg=='undefined'"><img src="assets/images/plusnew.png" height="50" /></span>
                <span *ngIf="profileImg"><img src="{{ profileImg }}" height="50" /></span>
                <i *ngIf="profileImg&&profileImg!==null&&profileImg!='undefined'"(change)="updateImage($event, 1)" class="fa-regular fa-pen-to-square"></i>
              </label>

            </div>
          </div>


        </div>
      </form>
      <div *ngIf="!isShowPaswordField" class="row">
        <div class="col-sm-12">
          <button style="float: right;" type="submit" class="btn btn-primary px-4" (click)="openChangePassword()">
            Change Password</button>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
</div>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus"
  [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>